import { REPORTING_API_BASE_URL } from "../../../app/utils";
import { getJwtToken } from "../../../app/common";

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${getJwtToken()}`,
});

const getChartData = async ({ endpoint, from, to, timeframe }) => {
  const url = `${REPORTING_API_BASE_URL}${endpoint}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&timeframe=${encodeURIComponent(timeframe)}`;
  const response = await fetch(url, {
    method: "GET",
    headers: authHeaders(),
  });

  if (!response.ok) {
    throw new Error(`Reporting API failed (${response.status}) for ${endpoint}`);
  }

  return response.json();
};

export const getParkingBookings = ({ from, to, timeframe }) =>
  getChartData({
    endpoint: "/reporting/v2/parking-bookings",
    from,
    to,
    timeframe,
  });

export const getActiveSubscribers = ({ from, to, timeframe }) =>
  getChartData({
    endpoint: "/reporting/v1/active-subscribers",
    from,
    to,
    timeframe,
  });
